import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var base64url = require("base64url");

var NotFoundPage = function NotFoundPage(_ref) {
  var config = _ref.pageContext.config,
      location = _ref.location;
  var siteConfig = config;
  var params = new URLSearchParams(location.search);
  var extraDataEncoded = params ? params.get("ExtraData") : null;
  var extraDataDecoded = extraDataEncoded ? base64url.decode(extraDataEncoded) : null;
  var extraDataDecodedSplit = extraDataDecoded ? extraDataDecoded.split("|") : [];
  return /*#__PURE__*/_jsx(Layout, {
    displayJACTA: false,
    siteConfig: siteConfig || {},
    location: location,
    description: extraDataDecodedSplit && extraDataDecodedSplit[4] ? extraDataDecodedSplit[4] : extraDataDecodedSplit && extraDataDecodedSplit[1] ? "Check out this vacancy from " + extraDataDecodedSplit[1] : "Check out this vacancy.",
    title: extraDataDecodedSplit && extraDataDecodedSplit[0] && extraDataDecodedSplit[1] ? extraDataDecodedSplit[0] + " | " + extraDataDecodedSplit[1] : extraDataDecodedSplit && extraDataDecodedSplit[0] ? extraDataDecodedSplit[0] : "Loading page...",
    children: /*#__PURE__*/_jsx("main", {
      id: "main",
      children: /*#__PURE__*/_jsx("div", {
        className: "page__header-container page__header-container--four-o-four-landing",
        children: /*#__PURE__*/_jsx("div", {
          className: "container",
          children: /*#__PURE__*/_jsx("div", {
            className: "row justify-content-center page__header page__header--landing four-o-four-landing__header page__header--four-o-four-landing",
            id: "listing-top",
            children: /*#__PURE__*/_jsx("div", {
              className: "col-12 col-lg-8",
              children: /*#__PURE__*/_jsxs("div", {
                className: "loading-panel",
                children: [/*#__PURE__*/_jsxs("div", {
                  className: "loading-ring",
                  children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("div", {})]
                }), /*#__PURE__*/_jsx("span", {
                  className: "loading-text",
                  children: "Please wait... If content is not shown soon then you may have the wrong URL."
                })]
              })
            })
          })
        })
      })
    })
  });
};

export default NotFoundPage;